<script>
	const analyticsUtilities = require('utilities/analyticsUtilities');

	const PRODUCT_PROMOTION_CLICK = analyticsUtilities.events.PRODUCT_PROMOTION_CLICK;

	module.exports = {
		props: {
			products: {
				default: []
			},
			itemsPerPage: {
				default: 3
			},
			onProductLinkClick: {
				default() {}
			},
			loc: {
				default: ''
			},
			labelId: {
				default: null
			}
		},
		data() {
			return {
				currentSlide: 0,
				setSlideFocus: false
			};
		},
		components: {
			'article-result-content': require('components/article-result-content.vue').default,
			carousel: require('components/carousel.vue').default,
			'carousel-slide': require('components/carousel-slide.vue').default
		},
		computed: {
			productPages() {
				let products = this.products;
				let itemsPerPage = this.itemsPerPage;
				let pages = [];

				for (let i = 0; i < products.length; i += itemsPerPage) {
					pages.push(products.slice(i, i + itemsPerPage));
				}

				return pages;
			}
		},
		methods: {
			onSlideChange(page, setSlideFocus) {
				this.currentSlide = page;
				this.setSlideFocus = setSlideFocus;

				analyticsUtilities.fireEvent(PRODUCT_PROMOTION_CLICK, {
					loc: this.loc,
					page: page + 1
				});
			},
			onProductClick(product) {
				this.onProductLinkClick({
					pid: product.uuid,
					loc: 'FEATURED_CONTENT'
				});
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';

	.featured-content-carousel {
		a.article.article-result-content {
			min-height: auto;

			.title-container {
				h2 {
					font-size: 1rem;
				}

				h3 {
					font-size: 0.75rem;
				}
			}

			.article-image .article-featured-image-container {
				height: 63px;
				width: 63px;
			}

			.article-meta {
				font-size: 0.75rem;

				.qset-totals,
				.text-type {
					display: none;
				}
			}
		}

		.carousel-cards {
			&.space-evenly {
				display: flex;
				flex-direction: column;
				justify-content: space-evenly;
			}
		}
	}
</style>
<template>
	<div class="featured-content-carousel">
		<carousel
			show-arrows
			show-pagination
			:total-slides="productPages.length"
			:label-id="labelId"
			@slide-change="onSlideChange"
			ref="carousel">
			<carousel-slide
				v-for="(p, index) in productPages"
				:key="index"
				:position="index"
				:total-slides="productPages.length"
				:current-slide="currentSlide"
				:set-focus="setSlideFocus">
				<div
					class="carousel-cards"
					:class="{
						'space-evenly': p.length === itemsPerPage
					}">
					<article-result-content
						v-for="product in p"
						:key="product.id"
						:article="product"
						:on-product-link-click="onProductClick"
						:show-summary="false">
					</article-result-content>
				</div>
			</carousel-slide>
		</carousel>
	</div>
</template>
